import { Button, Card, Table, Modal, Form, InputNumber, Input, Space, Drawer, Pagination } from 'antd';
import { useContext } from 'react';
import { Bar } from 'react-chartjs-2';
import CreateDrawer from '../../../components/create';
import { PageContext } from '../../../lib/context';
import CustomerReceit from '../customers/customer-receit';
import PayBills from './pay-bills';
import { CSVLink } from 'react-csv';
import Loading from '../../../components/loader';

export default function BillingsPage() {
  const { data, billingsTable, usersColumns, form, visible, setVisible, _onFinishSearch, handleSort, showDrawer, _closeDrawer, csv: billings, search_bill_loading, bill_table_loading, limit, offset, total, current, handlePaginationChange } = useContext(PageContext);
  console.log(billingsTable);

  return (
    <div className="flex flex-col px-10">
      <div className="items-start align-start">
        <p className="text-3xl font-bold">Billings</p>
      </div>
      {/* <div className="flex flex-row">
        <Card
          style={{
            borderRadius: 20,
            flexDirection: 'row',
            height: 300,
            width: 1000,
            marginRight: 20,
            display: 'none',
          }}
        >
          <div className="flex flex-row">
            <div className="mr-20 w-56">
              <p className="font-bold">Billed</p>
              <p className="text-xl font-bold">+ $20k today</p>
              <p className="text-xl font-bold">+ $340k this week</p>
              <p className="text-xl font-bold">+ $3.3m this month</p>
              <Button type="primary">See All Billing Stats</Button>
            </div>
            <div style={{ height: 230, width: 230 }}>
              <Bar height={300} width={300} data={data} type="line" />
            </div>
          </div>
        </Card>
      </div> */}
      <div className="flex flex-row mb-5">
        <Space>
          <Drawer
            visible={showDrawer}
            width={800}
            closable={true}
            onClose={_closeDrawer}
            title="Pay Bills"
            footer={
              <div
                style={{
                  textAlign: 'right',
                }}
              >
                <Button
                  onClick={_closeDrawer}
                  style={{ marginRight: 8 }}
                >
                  Close
                </Button>
                {/* <Button onClick={_submitHandler} type="primary">
                  Submit
                </Button> */}
              </div>
            }
          >
            <PayBills />
          </Drawer>
        </Space>
      </div>

      <p className="text-xl font-bold">Recent Billings</p>
      <div className="flex flex-row">
        <div className="w-full mr-3">
          <div className="mb-5">
            <Form layout="inline" onFinish={_onFinishSearch}>
              <Form.Item name="id">
                <Input
                  placeholder="Search by Bill ID or Customer ID"
                  style={{ width: 320 }}
                  allowClear
                  size="large"
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" size="large">
                  Search
                </Button>
              </Form.Item>
            </Form>
          </div>
          <div className="my-2 text-white bg-blue-700 rounded inline-block p-2 cursor-pointer">
            <CSVLink data={billings} className="tex-white" filename="Billings.csv">
              DOWNLOAD CSV FILE
            </CSVLink>
          </div>
          {bill_table_loading || search_bill_loading ? (
            <div className="mt-32">
              <Loading show={bill_table_loading || search_bill_loading} />
            </div>
          ) : (
            <>
              <Table dataSource={billingsTable} columns={usersColumns} pagination={false} onChange={handleSort} />
              <Pagination
                onChange={handlePaginationChange}
                showSizeChanger={true}
                pageSize={limit}
                current={current}
                total={total}
              />
            </>
          )
          }
        </div>
        <div>
          <Modal
            title="Bill Information"
            centered
            visible={visible}
            onCancel={() => setVisible(false)}
            width={1150}
            footer={
              <div style={{ textAlign: 'left' }}>
                <Form form={form} layout="vertical">
                  <Form.Item hidden={true} name="billing_id">
                    <InputNumber />
                  </Form.Item>
                  <Form.Item hidden={true} name="subscriber_id">
                    <InputNumber />
                  </Form.Item>
                </Form>
              </div>
              // <div style={{ textAlign: 'left' }}>
              //   <Form form={form} onFinish={_onFinish} layout="vertical">
              //     {/* {displayAmount && <> */}
              //       <Form.Item name="amount" rules={[{ required: true, message: "Amount is required" }]} label="Enter Amount">
              //         <div className="mb-2">
              //           <InputNumber placeholder="Enter Amount" style={{ width: 350 }} />
              //         </div>
              //       </Form.Item>
              //       <Form.Item hidden={true} name="billing_id">
              //         <InputNumber />
              //       </Form.Item>
              //       <Form.Item hidden={true} name="subscriber_id">
              //         <InputNumber />
              //       </Form.Item>
              //       <Form.Item>
              //         <Button type="primary" htmlType="submit">
              //           Submit
              //         </Button>
              //       </Form.Item>
              //     {/* </>} */}
              //   </Form>
              // </div>
            }
          >
            <CustomerReceit />
          </Modal>
        </div>
      </div>
    </div>
  );
}
